import { z } from 'zod';

/** File metadata stored in container workflow draft stepData. */
export const workflowContainerFileMetadataSchema = z.object({
  objectKey: z.string().min(1).max(250).trim(),
  originalName: z.string().min(1).max(250).trim(),
  mimeType: z.string().min(1).max(100).trim(),
  size: z.number().int(),
  uploadedAt: z.union([z.string(), z.date()]).optional(),
});

export type WorkflowContainerFileMetadata = z.infer<typeof workflowContainerFileMetadataSchema>;

type ContainerMediaStepData = {
  containerImages?: WorkflowContainerFileMetadata[];
  containerFiles?: WorkflowContainerFileMetadata[];
};

export function resolveContainerImages(
  stepData: ContainerMediaStepData,
): WorkflowContainerFileMetadata[] {
  return stepData.containerImages ?? [];
}

export function resolveContainerFiles(
  stepData: ContainerMediaStepData,
): WorkflowContainerFileMetadata[] {
  return stepData.containerFiles ?? [];
}

export function resolveContainerImageObjectKeys(stepData: ContainerMediaStepData): string[] {
  return resolveContainerImages(stepData).map((img) => img.objectKey);
}

export function resolveContainerFileObjectKeys(stepData: ContainerMediaStepData): string[] {
  return resolveContainerFiles(stepData).map((file) => file.objectKey);
}

export function parseContainerImagesFromStepData(
  stepData: Record<string, unknown> | undefined,
): WorkflowContainerFileMetadata[] {
  if (!stepData) {
    return [];
  }
  const parsed = z.array(workflowContainerFileMetadataSchema).safeParse(stepData.containerImages);
  return parsed.success ? parsed.data : [];
}

export function parseContainerFilesFromStepData(
  stepData: Record<string, unknown> | undefined,
): WorkflowContainerFileMetadata[] {
  if (!stepData) {
    return [];
  }
  const parsed = z.array(workflowContainerFileMetadataSchema).safeParse(stepData.containerFiles);
  return parsed.success ? parsed.data : [];
}
